import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './translationEN.json';
import translationDE from './translationDE.json';
import translationFR from './translationFR.json';
import translationNL from './translationNL.json';
import translationES from './translationES.json';
import translationIT from './translationIT.json';
import translationJA from './translationJA.json';
import translationKO from './translationKO.json';
import translationPT from './translationPT.json';
import translationDA from './translationDA.json';
import translationBG from './translationBG.json';
import translationCS from './translationCS.json';
import translationEL from './translationEL.json';
import translationET from './translationET.json';
import translationFI from './translationFI.json';
import translationHU from './translationHU.json';
import translationLT from './translationLT.json';
import translationLV from './translationLV.json';
import translationNO from './translationNO.json';
import translationPL from './translationPL.json';
import translationRO from './translationRO.json';
import translationSR from './translationSR.json';
import translationSV from './translationSV.json';
import translationTR from './translationTR.json';

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: translationEN
        },
        de: {
            translation: translationDE
        },
        fr: {
            translation: translationFR
        },
        nl: {
            translation: translationNL
        },
        es: {
            translation: translationES
        },
        it: {
            translation: translationIT
        },
        ja: {
            translation: translationJA
        },
        ko: {
            translation: translationKO
        },
        pt: {
            translation: translationPT
        },
        da: {
            translation: translationDA
        },
        bg: {
            translation: translationBG
        },
        cs: {
            translation: translationCS
        },
        el: {
            translation: translationEL
        },
        et: {
            translation: translationET
        },
        fi: {
            translation: translationFI
        },
        hu: {
            translation: translationHU
        },
        lt: {
            translation: translationLT
        },
        lv: {
            translation: translationLV
        },
        no: {
            translation: translationNO
        },
        pl: {
            translation: translationPL
        },
        ro: {
            translation: translationRO
        },
        sr: {
            translation: translationSR
        },
        sv: {
            translation: translationSV
        },
        tr: {
            translation: translationTR
        }
    },
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    }
});
export default i18n;